/**
 * Module dependencies.
 */

import { JSX } from 'react';
import { Product } from './product';
import { Wrapper } from './product-list.style';

/**
 * `Props` type.
 */

type Props = {
  category: any;
  subCategory: any;
};

/**
 * Export `ProductList` component.
 */

export function ProductList({ category, subCategory }: Props): JSX.Element {
  return (
    <Wrapper>
      {subCategory.products.map((product: any) => (
        <Product
          category={category}
          key={product.id}
          product={product}
          subCategory={subCategory}
        />
      ))}
    </Wrapper>
  );
}
